export const MODAL_DIALOG__ADD_PAGE_CONTENT = 'MODAL_DIALOG__ADD_PAGE_CONTENT';
export const MODAL_DIALOG__EDIT_PAGE_CONTENT = 'MODAL_DIALOG__EDIT_PAGE_CONTENT';
export const MODAL_DIALOG__EDIT_PAGE = 'MODAL_DIALOG__EDIT_PAGE';
export const MODAL_DIALOG__ADD_PAGE = 'MODAL_DIALOG__ADD_PAGE';
export const MODAL_DIALOG__EDIT_PAGE_CONTENT_SEO_DIALOG = 'MODAL_DIALOG__EDIT_PAGE_CONTENT_SEO_DIALOG';
